import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ShipperAccount } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ShipperAccountService extends TmsWebBaseEditCreateService<ShipperAccount, ShipperAccount> {
  constructor() {
    super('ShipperAccount', $localize`Shipper Account`);
  }

  getForSupplier(id: string): Observable<ShipperAccount[]> {
    return this.httpService.get<ShipperAccount[]>(`${this.apiUrl}/GetForSupplier?id=${id}`);
  }
}
